module.exports = __webpack_public_path__ + "img/home.c05e32fa.jpg";